import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

export function SettingsSurface({ children, className }: { children: React.ReactNode; className?: string }) {
	return <div className={cn("settings-surface", className)}>{children}</div>;
}

export function SettingToggle({
	id,
	label,
	description,
	checked,
	onChange,
	disabled,
}: {
	id: string;
	label: string;
	description?: string;
	checked: boolean;
	onChange: (value: boolean) => void;
	disabled?: boolean;
}) {
	return (
		<div className="setting-toggle">
			<div className="min-w-0">
				<Label htmlFor={id}>{label}</Label>
				{description && (
					<p id={`${id}-hint`} className="mt-1 text-sm text-muted-foreground">
						{description}
					</p>
				)}
			</div>
			<Switch
				id={id}
				checked={checked}
				onCheckedChange={onChange}
				disabled={disabled}
				aria-describedby={description ? `${id}-hint` : undefined}
			/>
		</div>
	);
}

export function PreviewStage({
	title,
	description,
	children,
}: {
	title: string;
	description: string;
	children: React.ReactNode;
}) {
	return (
		<aside className="settings-preview-stage" aria-label={title}>
			<div className="mb-5 text-center">
				<h3 className="text-sm font-semibold">{title}</h3>
				<p className="mt-1 text-xs text-muted-foreground">{description}</p>
			</div>
			{children}
		</aside>
	);
}
